import { Button } from '@mui/material';
import { nanoid } from 'nanoid';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';
import { MAX_QUESTION_ADDED } from '../../utils/constants';
import QuestionContainer from './QuestionContainer';

const WritePaper = forwardRef(({ questions, updateArray, handleNext }, ref) => {
  const [qusArray, setQusArray] = useState(questions);

  const updateQueList = (index, data) => {
    const newQus = [...qusArray];
    const hasAnsNotSelectedProp = Object.prototype.hasOwnProperty.call(data, 'isAnsNotSelected');
    const hasTitleIsErrorProp = Object.prototype.hasOwnProperty.call(data, 'isError');
    const hasNameProp = Object.prototype.hasOwnProperty.call(data, 'name');
    const hasOptionsProp = Object.prototype.hasOwnProperty.call(data, 'options');
    const hasFileObjProp = Object.prototype.hasOwnProperty.call(data, 'fileObj');
    if (hasNameProp) {
      newQus[index].name = data.name;
    }
    if (hasOptionsProp) {
      newQus[index].options = data.options;
    }
    if (hasFileObjProp) {
      newQus[index].fileObj = data.fileObj;
    }
    if (hasAnsNotSelectedProp) {
      newQus[index].isAnsNotSelected = data.isAnsNotSelected;
    }
    if (hasTitleIsErrorProp) {
      newQus[index].isError = data.isError;
    }
    setQusArray(newQus);
    updateArray(newQus);
  };

  const addQuestion = () => {
    const obj = {
      _id: nanoid(),
      name: '',
      isError: false,
      isAnsNotSelected: true,
      options: [
        {
          _id: nanoid(),
          value: '',
          isAnswer: false,
          isError: false
        },
        {
          _id: nanoid(),
          value: '',
          isAnswer: false,
          isError: false
        }
      ]
    };
    setQusArray([...qusArray, obj]);
    updateArray([...qusArray, obj]);
  };

  const removeQuestion = (i) => {
    setQusArray([...qusArray.slice(0, i), ...qusArray.slice(i + 1)]);
    updateArray([...qusArray.slice(0, i), ...qusArray.slice(i + 1)]);
  };

  const checkValid = () => {
    let isValid = true;
    const newQusArray = [...qusArray];
    for (let i = 0; i < newQusArray.length; i += 1) {
      const element = newQusArray[i];
      let objValid = true;
      // First check for all options that are not null
      for (let j = 0; j < element.options.length; j += 1) {
        const subElement = element.options[j];
        if (subElement.value.trim() === '') {
          subElement.isError = true;
          objValid = false;
        } else {
          subElement.isError = false;
        }
      }
      // Check for question name is not null
      if (element.name.trim() === '') {
        element.isError = true;
        objValid = false;
      } else {
        element.isError = false;
      }
      // Check if ans not selected
      if (element.isAnsNotSelected) {
        objValid = false;
      }
      // Flag for validating all objects
      // If any object has error then will check for if objValid is false and isValid true
      // Cause this two are function level variables that's it is change on every time when we call this method.
      if (!objValid && isValid) {
        isValid = false;
      }
    }
    // Setting new array to existing one with any error is happen
    setQusArray(newQusArray);
    return isValid;
  };

  useImperativeHandle(ref, () => ({
    handlePaperSubmit() {
      if (checkValid()) {
        handleNext(qusArray);
      }
    }
  }));

  return (
    <div style={{ marginTop: 15 }}>
      {qusArray.map((qo, i) => (
        <QuestionContainer
          key={qo._id}
          number={i + 1}
          fileObj={qo?.fileObj ?? null}
          questionTitle={qo.name}
          answers={qo.options}
          updateQuestion={(data) => updateQueList(i, data)}
          removeQues={() => removeQuestion(i)}
          titleError={qo.isError}
          optionSelectionError={qo.isAnsNotSelected}
        />
      ))}
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}>
        <Button disabled={qusArray.length === MAX_QUESTION_ADDED} onClick={() => addQuestion()}>
          + Add Question
        </Button>
      </div>
      {/* <div className={classes.btnContainer}>
        <Button variant="outlined" onClick={() => handleBack()} className={classes.btnStyle}>
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleSubmit()}
          className={classes.btnStyle}
        >
          Next
        </Button>
      </div> */}
    </div>
  );
});

WritePaper.propTypes = {
  questions: PropTypes.array,
  updateArray: PropTypes.func,
  handleNext: PropTypes.func
};

export default WritePaper;
